import { ReactNode } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ImagineMenu from "../../components/ImagineMenu/ImagineMenu";
import ImagineInput from "@/components/ImagineInput/ImagineInput";
import PrivateRoute from "@/components/Auth/PrivateRoute/PrivateRoute";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import styles from "./ImagineContainer.module.scss";

interface MainContainerProps {
  children: ReactNode;
  formValid: boolean;
  handleGenerate: () => void;
}

const ImagineContainer = (props: MainContainerProps) => {
  return (
      <PrivateRoute>
          <div className={styles.imagineContainer}>
              <div className={styles.imagineContent}>
                  <Navbar />

                  <main className={styles.mainContent}>
                      <div className={styles.children}>{props.children}</div>
                      <div className={styles.input}>
                          <ImagineInput
                              isFormValid={props.formValid}
                              handleGenerate={props.handleGenerate}
                          />
                      </div>
                  </main>
              </div>
          </div>
      </PrivateRoute>
  );
};

export default ImagineContainer;
